// extracted by mini-css-extract-plugin
export default {"galleryHeader":"GalleryHeader_galleryHeader__9JoAV","title":"GalleryHeader_title__GRM7w","mobile":"GalleryHeader_mobile__Qzld-","subTitle":"GalleryHeader_subTitle__PXFfj"};